module.exports = __webpack_public_path__ + "img/STERiGLIDE_00_03.5bc4cfe3.png";